import React, { useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../store/global';
import API from '../lib/api';

import ComeBack from '../components/common/ComeBack';
import RechargeItem from '../components/common/RechargeItem';
import NetworkItem from '../components/common/NetworkItem';
import CurrencyInputbox from '../components/common/CurrencyInputbox';
import ExchangeRate from '../components/common/ExchangeRate';
import NormalButton from '../components/common/NormalButton';

import PseIcon from '../assets/images/pse.png';
import Pse2xIcon from '../assets/images/pse_2x.png';
import BlockchainIcon from '../components/svg/BlockchainIcon';
import ArrowCircleUpRightIcon from '../components/svg/ArrowCircleUpRightIcon';

import blockchainImage from '../assets/images/blockchain/blockchain.png';
import ethereumImage from '../assets/images/blockchain/ethereum.png';
import bnbImage from '../assets/images/blockchain/bnb.png';
import tetherImage from '../assets/images/blockchain/tether.png';
import solanaImage from '../assets/images/blockchain/solana.png';
import colombiaFlag from '../assets/images/country/colombia.png';
import usFlag from '../assets/images/country/us.png';
import QrcodeImage from '../assets/images/qrcode.png';

const blockchains = [
  // {
  //   icon: blockchainImage,
  //   name: 'Bitcoin',
  //   currency: 'BTC',
  // },
  // {
  //   icon: ethereumImage,
  //   name: 'Ethereum',
  //   currency: 'ETH',
  // },
  // {
  //   icon: bnbImage,
  //   name: 'BNB Chain',
  //   currency: '',
  // },
  // {
  //   icon: tetherImage,
  //   name: 'Tether',
  //   currency: 'USDT',
  // },
  {
    icon: solanaImage,
    name: 'Solana',
    currency: 'USDC',
  },
];

export default function Rewards() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const [progress, setProgress] = useState(0);
  const [rechargeType, setRechargeType] = useState(''); // PSE, BLOCKCHAIN
  const [blockchain, setBlockchain] = useState('');
  const [copValue, setCopValue] = useState('');
  const [dollarValue, setDollarValue] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [copied, setCopied] = useState(false);
  const [checkoutLink, setCheckoutLink] = useState('');
  const [exchangeRate, setExchangeRate] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [exchangeRate_, setExchangeRate_] = useState();

  useEffect(() => {
    getExchangeRate_();
  }, [])
  const getExchangeRate_ = async () => {
    const res = await API.get('transaction/get_exchange_rate');
    if(res.data.success == true) {
      setExchangeRate(res.data.rate);
    } else {
      console.log(res.data);
    }
  }

  useEffect(() => {
    const developerFee = parseFloat(import.meta.env.VITE_DEVELOPER_FEE);
    setDollarValue((copValue / exchangeRate) * (1 - developerFee / 100.0));
  }, [copValue, exchangeRate]);

  const onChangeRechargeType = (type) => {
    setRechargeType(type);
    setProgress(progress + 1);
  };
  const onChangeNetwork = (type) => {
    API.get('user/getWalletAddress')
      .then((res) => {
        console.log('res: ', res);
        setBlockchain(type);
        setProgress(progress + 1);
        setWalletAddress(res.data.data.address);
      })
      .catch((err) => {
        console.log('err: ', err);
        if (err.status == 401) navigate('/login');
      });
  };
  const onCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(walletAddress);
      setCopied(true);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  const onPurchaseOrder = async () => {
    if (submitting) return;
    setSubmitting(true);

    await API.post('transaction/onRampByPayvalida', {
      amount: copValue,
      exchangeRate: exchangeRate,
    })
      .then((res) => {
        console.log('res: ', res);
        setCheckoutLink(res.data.data.checkout);
        setProgress(progress + 1);
        setSubmitting(false);
      })
      .catch((err) => {
        console.log('err: ', err);
        setSubmitting(false);
        if (err.status == 401) navigate('/login');
      });
  };

  const onCheckout = () => {
    const url = `https://${checkoutLink}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setProgress(0);
  };

  return (
    <div className="relative py-8 flex items-center justify-center">
      <div className="w-153.5 bg-white border border-[#E6EBF7] rounded-[20px] p-6 space-y-6">
        {progress == 0 && (
          <>
            <div className="space-y-2">
              <ComeBack
                text="Recargar"
                onClick={() => navigate('/dashboard')}
              />
              <p className="text-sm text-[#535862] font-normal leading-[20px]">
                Selecciona el método de recarga
              </p>
            </div>

            <div className="space-y-2">
              <RechargeItem
                leftIcon={<img src={PseIcon} className="w-full h-full" />}
                title="PSE"
                subTitle="(Pagos seguros en línea)"
                onClick={() => onChangeRechargeType('PSE')}
              />
              <RechargeItem
                leftIcon={<BlockchainIcon />}
                title="Dirección de blockchain"
                onClick={() => onChangeRechargeType('BLOCKCHAIN')}
              />
            </div>
          </>
        )}

        {progress == 1 && (
          <>
            {rechargeType == 'PSE' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de PSE"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="text-sm text-[#535862] font-normal leading-[20px]">
                    Ingresa el monto que deseas recargar
                  </p>
                </div>

                <div className="space-y-4">
                  <CurrencyInputbox
                    title="Envias"
                    icon={colombiaFlag}
                    currency="COL"
                    value={copValue}
                    onChange={setCopValue}
                  />
                  <CurrencyInputbox
                    disabled={true}
                    title="Recibes"
                    icon={usFlag}
                    currency="USD"
                    value={dollarValue}
                    onChange={setDollarValue}
                  />
                </div>

                <div className="space-y-2 mb-6 text-xs text-[#414651] font-medium leading-[20px]">
                  <ExchangeRate colRate={exchangeRate_} rate={exchangeRate} />
                  <p className="text-xs font-medium text-center">
                    La cotización se actualizará en{' '}
                    <span className="text-[#07276B]">50 segundos</span>
                  </p>
                </div>

                <div className="float-right">
                  <NormalButton
                    customClass="bg-[#092F7B] text-white"
                    text="Continuar"
                    onClick={onPurchaseOrder}
                  />
                </div>
              </>
            )}
            {rechargeType == 'BLOCKCHAIN' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de dirección de Blockchain"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="text-sm text-[#535862] font-normal leading-[20px]">
                    Seleccion la red con la que quieres recargar
                  </p>
                </div>

                <div className="space-y-2">
                  {blockchains.map((item, idx) => (
                    <NetworkItem
                      key={idx}
                      item={item}
                      onClick={() => onChangeNetwork(item.name)}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}

        {progress == 2 && (
          <>
            {rechargeType == 'PSE' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de PSE"
                    onClick={() => setProgress(progress - 1)}
                  />
                </div>

                <div>
                  <div className="py-6 space-y-2 text-center">
                    <div className="flex items-center justify-center">
                      <div className="relative w-20 h-20 bg-[#E6EBF7] rounded-full flex items-center justify-center">
                        <img
                          src={Pse2xIcon}
                          alt="pse 2x image"
                          className="w-[73px] h-65px"
                        />
                        <div className="absolute bottom-0 right-2 w-6.5 h-6.5 bg-white rounded-full">
                          <ArrowCircleUpRightIcon size="w-6.5 h-6.5" />
                        </div>
                      </div>
                    </div>
                    <div className="py-2 space-y-2">
                      <p className="text-sm text-[#252B37] font-medium leading-[22px]">
                        Estas siendo redireccionado a la página oficial de PSE
                        para completar el pago
                      </p>
                      <p className="text-sm text-[#717680] font-normal leading-[20px]">
                        Una vez finalizado el proceso, podrás ver tu recarga
                        reflejada en tu cuenta.
                      </p>
                    </div>
                  </div>

                  <div className="float-right">
                    <NormalButton
                      customClass="bg-[#092F7B] text-white"
                      text="Continuar"
                      onClick={onCheckout}
                    />
                  </div>
                </div>
              </>
            )}

            {rechargeType == 'BLOCKCHAIN' && (
              <>
                <div className="space-y-2">
                  <ComeBack
                    text="Recargar a través de dirección de Blockchain"
                    onClick={() => setProgress(progress - 1)}
                  />
                  <p className="text-sm text-[#535862] font-normal leading-[20px]">
                    Transfiere, sin comisiones, desde la billetera seleccionada
                    a tu cuenta Flowex.
                  </p>
                </div>

                <div className="space-y-2 text-center">
                  <p className="text-sm text-[#061F5B] font-medium leading-[22px]">
                    Dirección Solana (USDC)
                  </p>
                  <div className="flex items-center justify-center">
                    <div className="p-4 border border-[#A4B9E5] rounded-[20px]">
                      <img
                        src={QrcodeImage}
                        alt="Qrcode"
                        className="w-64 h-64"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-[#F5F8FF] rounded-[10px] space-y-1">
                  <p className="text-xs text-[#252B37] font-normal leading-[20px]">
                    Dirección de billetera
                  </p>
                  <div className="space-x-2 flex items-center justity-between leading-[20px]">
                    <p className="w-full bg-white px-3 py-2 text-sm text-[#414651] font-normal border border-[#535862] rounded-[10px]">
                      {walletAddress}
                    </p>
                    <button
                      onClick={onCopyToClipboard}
                      className="relative bg-[#FDFDFD] px-6 py-2 text-sm text-[#2A59C6] font-medium border border-[#2A59C6] rounded-[10px]"
                    >
                      <span>{copied ? 'Copiada' : 'Copiar'}</span>
                    </button>
                  </div>
                </div>

                <div className="float-right">
                  <NormalButton
                    customClass="bg-[#092F7B] text-white"
                    text="Volver a inicio"
                    onClick={() => setProgress(0)}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
